module.exports = "https://web-assets.ifttt.com/packs/media/card_brands/dinersclub-910a9f18.png";